import Vue from 'vue'
import axios from 'axios'
import store from '@/store'
import AuthService from '@/service/auth/AuthService'
import {
  camelCaseKeys,
} from '@/util'

const _axios = axios.create({
  baseURL: `${store.state.env.baseURL}`
})

_axios.interceptors.request.use(config => {
  store.dispatch('loading/setIsLoading', true)
  if (config.headers.Authorization == null) {
    let token = localStorage.getItem(store.state.env.token.name)
    if (token != null) {
      config.headers.Authorization = `JWT ${token}`
    }
  }
  return config
}, error => {
  // Do something with request error
  store.dispatch('loading/setIsLoading', false)
  return Promise.reject(error)
})

// Add a response interceptor
_axios.interceptors.response.use((response) => {
  store.dispatch('loading/setIsLoading', false)
  if (response.config?.snakeToCamel === true) {
    return {
      ...response,
      data: camelCaseKeys(response.data)
    }
  }
  return response
}, error => {
  // Do something with response error
  store.dispatch('loading/setIsLoading', false)
  if (error.response && error.response.data) {
    console.log(JSON.stringify(error.config))
    console.log(JSON.stringify(error.response.data))
  }
  return Promise.reject(error.response)
})

_axios.call = async function (option) {
  if (option.data != null && option.data.isAwait === false) {
    delete option.data.isAwait
  } else {
    await AuthService.sync()
  }
  return _axios(Vue.util.extend({}, option))
}

export default _axios
